/*
 * Swiss German orthography: replace ß with ss in all visible text.
 * Loaded only when the storefront is German + Switzerland (see theme.liquid).
 */
(() => {
  const hasEszett = (s) => s.includes('ß') || s.includes('ẞ');
  const fixString = (s) => s.replaceAll('ß', 'ss').replaceAll('ẞ', 'SS');
  const SKIP_TAGS = new Set(['SCRIPT', 'STYLE', 'NOSCRIPT', 'TEXTAREA', 'INPUT', 'CODE']);
  const ATTRS = ['placeholder', 'title', 'alt', 'aria-label'];

  const fixTextNodes = (root) => {
    if (root.nodeType === Node.TEXT_NODE) {
      if (hasEszett(root.nodeValue)) root.nodeValue = fixString(root.nodeValue);
      return;
    }
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: (node) =>
        SKIP_TAGS.has(node.parentElement?.tagName)
          ? NodeFilter.FILTER_REJECT
          : hasEszett(node.nodeValue)
            ? NodeFilter.FILTER_ACCEPT
            : NodeFilter.FILTER_SKIP,
    });
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    nodes.forEach((node) => (node.nodeValue = fixString(node.nodeValue)));
  };

  const fixAttributes = (root) => {
    if (root.nodeType !== Node.ELEMENT_NODE && root.nodeType !== Node.DOCUMENT_NODE) return;
    const selector = ATTRS.map((a) => `[${CSS.escape(a)}]`).join(',');
    const elements = root.querySelectorAll(selector);
    const fixEl = (el) => {
      ATTRS.forEach((attr) => {
        const value = el.getAttribute(attr);
        if (value && hasEszett(value)) el.setAttribute(attr, fixString(value));
      });
    };
    if (root.nodeType === Node.ELEMENT_NODE) fixEl(root);
    elements.forEach(fixEl);
  };

  const fixAll = (root) => {
    fixTextNodes(root);
    fixAttributes(root);
  };

  fixAll(document);

  // Content injected later (cart drawer, section rerenders, app widgets).
  // Replacements above leave no ß behind, so observer callbacks can't loop.
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'characterData') {
        fixTextNodes(mutation.target);
      } else {
        mutation.addedNodes.forEach((node) => fixAll(node));
      }
    });
  });
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
    characterData: true,
  });
})();
